import React, { useContext, useMemo } from "react";

import "./EUMRVVoyages.scss";

import {
	EUMRV_VOYAGES_HEADERS,
	EuVoyagesDerogationPhaseInColumns,
} from "../../../../../../constants/CustomTableHeaders";
import CustomTable from "../../../../../../common/customTable/CustomTable";
import { ClaimsContext } from "../../../../../../services/ClaimsService";
import { FeatureType } from "../../../../../../constants/FeatureToggles";

const EuVoyagesDerogationPhaseIn = ({ data }) => {
		const mrvAccessorKeys = [
		"co2Mrv",
		"ch4Mrv",
		"n2oMrv",
		"co2EqMrv",
	];
	
	const dynamicColumns = useMemo(() => {
			
			return EuVoyagesDerogationPhaseInColumns?.filter(
				col => !mrvAccessorKeys.includes(col.accessorKey)
			);

	}, [EuVoyagesDerogationPhaseInColumns]);

	return (
		<div className="EUMRV-custom-table-container mt-3 eu_mrv_voyage">
			<CustomTable
				columnsData={dynamicColumns}
				renderTableData={data || []}
				customProps={{
					header: EUMRV_VOYAGES_HEADERS.PHASE_IN,
					enableSort: false,
					tableName: "emissions-report",
					maxHeight: "30vh",
				}}
			/>
		</div>
	);
};

export default EuVoyagesDerogationPhaseIn;
